import * as React from "react";
import { Form as BSForm, Button } from "reactstrap";
import { observer } from "mobx-react";
import { FormStore } from "../../stores/FormStore";
import {SubmissionError} from "../../utils/networking";
//import { SubmissionError } from "../../utils/networking";

interface IFormProps {
    id?: string;
    store: FormStore<any>;
    showSubmitButton?: boolean;
    submitButtonText?: string ;
    children?: any;
}

@observer
export default class Form extends React.Component<IFormProps> {
    handleSubmit = (e: any) => {
        e.preventDefault();
        this.props.store.submit().catch((response: any) => {
            if (response instanceof SubmissionError) {
                this.props.store.setErrors(response);
                // TODO
                // rootStore.messageStore.showErrorMessage(response.message);
            }
        });
    };

    render() {
        const { children, id, showSubmitButton = true , submitButtonText = 'Submit'} = this.props;
        return (
            <BSForm onSubmit={this.handleSubmit} id={id}>
                {children}
                {showSubmitButton && (
                    <Button onClick={this.handleSubmit} type="submit" color="primary"  style={{marginReft: '0',marginLeft:  'auto',display: 'block' }}>
                        { submitButtonText }
                    </Button>
                )}
            </BSForm>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/form/Form.tsx